var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btClose",class:{on: _vm.isEditMode},on:{"click":_vm.remove}})
}
var staticRenderFns = []

export { render, staticRenderFns }